/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, AppBar, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdMail, MdPhone } from "react-icons/md";
import styles from "./uni_overview_campus.module.scss";
import parse from "html-react-parser";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#fff",
  },
}));

export const UniOverviewCampus = ({ universityProfileData }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/university-campus/${universityProfileData?.universitySlug}`
        );
        setLoading(false);
        setData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, []);

  return (
    <section>
      <div className="container">
        <div className={styles.title_wrapper}>
          <h2>Campus & Contact</h2>
          <p className={styles.short_description}>
            Explore{" "}
            <span style={{ fontWeight: 500 }}>
              {universityProfileData?.universityName}’s{" "}
            </span>
            campuses, location, and surroundings, and get in touch with the
            university itself to find out more!
          </p>
        </div>
        <div className={styles.campuses_wrapper}>
          {data?.length == 0 ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={6}>
                <div className={styles.campus_address_wrapper}>
                  <div className={styles.campus_address_title}>Main Campus</div>
                  <ul className={styles.address}>
                    <li>
                      <FaMapMarkerAlt />
                      <span>
                        Address: <br />
                        {universityProfileData?.address}
                      </span>
                    </li>
                    <li>
                      <MdMail />
                      <span>
                        Email: <br />
                        {universityProfileData?.email}
                      </span>
                    </li>
                    <li>
                      <MdPhone />
                      <span>
                        Phone: <br />
                        {universityProfileData?.phone}
                      </span>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <div className={`${styles.map_wrapper} CampusMapWrapper`}>
                  {universityProfileData?.location
                    ? parse(universityProfileData?.location)
                    : ""}
                </div>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12} sm={12} md={6}>
                <div className={styles.tabs_wrapper}>
                  <div className="uni_campuses">
                    <div className={classes.root}>
                      <AppBar position="static" color="default">
                        <Tabs
                          value={value}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="primary"
                          variant="scrollable"
                          scrollButtons="auto"
                          aria-label="scrollable auto tabs example"
                        >
                          {data.map((campus, i) => (
                            <Tab
                              label={campus?.campusName}
                              {...a11yProps(i)}
                              key={i}
                            />
                          ))}
                        </Tabs>
                      </AppBar>
                      {data?.map((campus, i) => {
                        return (
                          <TabPanel value={value} index={i} key={i}>
                            <ul className={styles.address}>
                              <li>
                                <FaMapMarkerAlt />
                                <span>
                                  Address: <br />
                                  {campus?.campusAddress}
                                </span>
                              </li>
                              <li>
                                <MdMail />
                                <span>
                                  Email: <br />
                                  {campus?.campusEmail}
                                </span>
                              </li>
                              <li>
                                <MdPhone />
                                <span>
                                  Phone: <br />
                                  {campus?.campusPhone}
                                </span>
                              </li>
                            </ul>
                          </TabPanel>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <div className={`${styles.map_wrapper} CampusMapWrapper`}>
                  {data.map((campus, i) => {
                    return (
                      <TabPanel
                        value={value}
                        index={i}
                        key={i}
                        style={{ height: "100%" }}
                      >
                        <iframe
                          src={`https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14610.12323499123!2d${campus?.campusLongitude}!3d${campus?.campusLattitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1641754942272!5m2!1sen!2sbd`}
                          width="100%"
                          height="356px"
                          style={{ border: 0 }}
                          allowfullssreen=""
                          loading="lazy"
                        ></iframe>
                      </TabPanel>
                    );
                  })}
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    </section>
  );
};

export default UniOverviewCampus;
